import { useTheme } from '@mui/material';

export const ClockIcon = () => {
    const theme = useTheme();
    const themeInfoColour = theme.palette.info.main;

    return (
        <svg
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M6.99984 13.3333C10.2215 13.3333 12.8332 10.7216 12.8332 7.49996C12.8332 4.2783 10.2215 1.66663 6.99984 1.66663C3.77818 1.66663 1.1665 4.2783 1.1665 7.49996C1.1665 10.7216 3.77818 13.3333 6.99984 13.3333Z"
                stroke={themeInfoColour}
            />
            <path
                d="M7 5.16663V7.49996L8.16667 8.66663"
                stroke={themeInfoColour}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
